import { render, staticRenderFns } from "./EditSlider.vue?vue&type=template&id=57b78de8&scoped=true"
import script from "./EditSlider.vue?vue&type=script&lang=ts"
export * from "./EditSlider.vue?vue&type=script&lang=ts"
import style0 from "./EditSlider.vue?vue&type=style&index=0&id=57b78de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b78de8",
  null
  
)

export default component.exports